/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Soft_Keen_Wolf_GazeInputs */

const en_soft_keen_wolf_gaze = /** @type {(inputs: Soft_Keen_Wolf_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure which data is used for this round.`)
};

const de_soft_keen_wolf_gaze = /** @type {(inputs: Soft_Keen_Wolf_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfigurieren Sie, welche Daten für diese Runde verwendet werden.`)
};

/**
* | output |
* | --- |
* | "Configure which data is used for this round." |
*
* @param {Soft_Keen_Wolf_GazeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const soft_keen_wolf_gaze = /** @type {((inputs?: Soft_Keen_Wolf_GazeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Keen_Wolf_GazeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_soft_keen_wolf_gaze(inputs)
	return de_soft_keen_wolf_gaze(inputs)
});